module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchPlaceholder":"Name"},"de":{"searchPlaceholder":"Name"},"fr":{"searchPlaceholder":"Nom"},"it":{"searchPlaceholder":"Nome"}}')
  delete Component.options._Ctor
}
